import { IconDefinition } from '@fortawesome/fontawesome-svg-core'

const isIcon = (icon: any): icon is IconDefinition =>
  typeof icon === 'object' && icon !== null && icon.iconName !== undefined

export default isIcon
